import { useCallback, useEffect, useState } from "react";

/**
 * Product login session (/api/me). Distinct from Okta SSWS capabilities (AuthContext).
 */
export function useProductMe() {
  const [me, setMe] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch("/api/me", { credentials: "include" });
      const json = await res.json().catch(() => ({ authenticated: false, user: null }));
      setMe(json);
      return json;
    } catch {
      const fallback = { authenticated: false, user: null };
      setMe(fallback);
      return fallback;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { me, loading: me === undefined, refresh };
}

export async function productLogout() {
  await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
}
